import { ModalBody, Container, ModalFooter, ModalHeader } from './styles'
import { MdClose } from 'react-icons/md'
import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { InputCmp } from '../../../../../../components/InputCmp'
import { iModalPadrao } from '../../../../../../interfaces'

interface IModal extends iModalPadrao {
  competenciaId: string
  duplicar: boolean
  questaoId?: string
  CriarQuestao: (compId: string, texto: string) => void
  UpdateQuestao: (compId: string, questaoId: string, texto: string) => void
  textoPadrao?: string
}

export const ModalQuestao: React.FC<IModal> = ({ OnCloseModal, isOpen, competenciaId, questaoId, duplicar, CriarQuestao, UpdateQuestao, textoPadrao }) => {
  if (!isOpen) {
    return null
  }
  const [Texto, setTexto] = useState('')

  useEffect(() => {
    if (textoPadrao) {
      setTexto(textoPadrao)
    }
  }, [textoPadrao])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={OnCloseModal}
      overlayClassName='react-modal-overlay'
      className='react-modal-content-default'
    >
      <Container>
        <ModalHeader>
          <h3>{questaoId === undefined ? 'Criar' : 'Editar'} Questão</h3>
          <MdClose
            onClick={() => OnCloseModal()}
            cursor={'pointer'}
            size={18}
          />
        </ModalHeader>

        <ModalBody>
          <InputCmp
            placeholder='Digite uma questão aqui'
            OnChange={setTexto}
            value={Texto}
          />
        </ModalBody>

        <ModalFooter>
          {
            (questaoId === undefined && !duplicar) && (
              <ButtonCmp
                VarColor='Green2'
                onClick={() => { CriarQuestao(competenciaId, Texto); OnCloseModal() }}
              >Criar questão</ButtonCmp>
            )
          }

          {
            (questaoId !== undefined && !duplicar) && (
              <ButtonCmp
              VarColor='Green2'
              onClick={() => { UpdateQuestao(competenciaId, questaoId, Texto); OnCloseModal() }}
              >Editar questão</ButtonCmp>
            )
          }

          {
            (questaoId !== undefined && duplicar) && (
              <ButtonCmp
                VarColor='Green2'
                // onClick={() => { CriarQuestao(competenciaId, Texto, ITipo); OnCloseModal() }}
              >Duplicar questão</ButtonCmp>
            )
          }
        </ModalFooter>
      </Container>
    </Modal>
  )
}
